import React, { useState, useEffect } from 'react';
import { BrowserRouter } from "react-router-dom";
import Navbar from './Header';
import Footer from './Fotter';
import WhatsAppButton from './WhatsAppButton';
import './App.css';

function App() {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const hasConsented = localStorage.getItem('cookie_consent');
    if (!hasConsented) {
      setShowBanner(true);
    }
  }, []);

  const handleClose = () => {
    localStorage.setItem('cookie_consent', 'true');
    setShowBanner(false);
  };

  return (
    <>
      <BrowserRouter>
        <div className="min-h-screen flex flex-col justify-between bg-white relative">
          <div>
            <Navbar />
          </div>
          <Footer />

          {/* Floating WhatsApp Quick Connect with Pre-filled Discovery Redirect */}
          <WhatsAppButton />
        </div>
      </BrowserRouter>

      {showBanner && (
        <aside aria-label="Cookie consent banner" className="fixed bottom-4 left-4 sm:left-6 z-50 max-w-sm w-[90%] sm:w-80 animate-bounce-short">
          <div className="bg-white rounded-xl shadow-2xl border border-gray-100 p-5">
            <div className="flex items-center justify-between mb-2">
              <div className="flex items-center gap-2">
                <img src="https://www.svgrepo.com/show/401340/cookie.svg" alt="Cookie policy icon" className="h-6 w-6" width="24" height="24" />
                <span className="text-gray-900 font-bold text-sm">Cookie Policy</span>
              </div>
              <button 
                className="text-gray-600 hover:text-gray-900 p-1" 
                onClick={handleClose}
                aria-label="Dismiss cookie policy banner"
              >
                <svg className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"></path>
                </svg>
              </button>
            </div>
            <p className="text-gray-600 text-xs leading-relaxed">
              We use cookies to improve your experience and deliver optimized service solutions.
            </p>
            <div className="mt-3 flex gap-2">
              <button 
                className="w-full bg-red-600 hover:bg-red-700 text-white font-semibold py-2 px-3 text-xs rounded-lg shadow transition" 
                onClick={handleClose}
              >
                Accept All
              </button>
            </div>
          </div>
        </aside>
      )}
    </>
  );
}

export default App;
